import { Directive, HostBinding } from '@angular/core';

@Directive({
  // tslint:disable:directive-selector
  selector: '[ls-heading4]'
})
export class Heading4Directive {
  @HostBinding('class.cr-text--heading4') public heading4 = true;
}
